/**
 * Test IDs for QA automation.
 */
export const testIds = {
  planningToolActions: "planning-tool-actions",
  planningToolFilterAssets: "planning-tool-filter-assets",
  planningToolAutoPlan: "planning-tool-auto-plan",
  planningToolToggleUnplannedOrders: "planning-tool-toggle-unplanned-orders",
  planningToolPlan: "planning-tool-plan",
  planningToolRevert: "planning-tool-revert",
  planningToolSave: "planning-tool-save",
} as const;
